import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "panel"]
  static values = { open: Boolean }

  connect() {
    this.boundKey = this.handleKey.bind(this)
    document.addEventListener("keydown", this.boundKey)
    window.addEventListener("cart:open", () => this.open())
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKey)
  }

  panelTargetConnected(el) {
    // Re-apply open state when panel is replaced by Turbo Stream
    if (this.openValue) {
      el.classList.remove("hidden", "translate-x-full")
      this.backdropTarget?.classList.remove("hidden")
    }
  }

  open() {
    this.openValue = true
  }

  close() {
    this.openValue = false
  }

  openValueChanged() {
    if (!this.hasPanelTarget || !this.hasBackdropTarget) return
    if (this.openValue) {
      this.backdropTarget.classList.remove("hidden")
      this.panelTarget.classList.remove("hidden")
      requestAnimationFrame(() => {
        this.panelTarget.classList.remove("translate-x-full")
      })
      document.body.style.overflow = "hidden"
    } else {
      this.panelTarget.classList.add("translate-x-full")
      setTimeout(() => {
        this.backdropTarget.classList.add("hidden")
        this.panelTarget.classList.add("hidden")
      }, 200)
      document.body.style.overflow = ""
    }
  }

  handleKey(e) {
    if (e.key === "Escape" && this.openValue) this.close()
  }
}
